import { render, staticRenderFns } from "./dj-media-icon.vue?vue&type=template&id=5b11e0da&scoped=true&"
import script from "./dj-media-icon.vue?vue&type=script&lang=js&"
export * from "./dj-media-icon.vue?vue&type=script&lang=js&"
import style0 from "./dj-media-icon.vue?vue&type=style&index=0&id=5b11e0da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b11e0da",
  null
  
)

export default component.exports